const moneyMixin = {
    methods: {
        formatMoney(value) {
            if (!value) value = 0;
            return Number(value).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL"
            });
        }
    },
    data: function () {
        return {
            money_options: {
                locale: "pt-BR",
                prefix: "R$",
                suffix: "",
                length: 11,
                precision: 2,
            },
        }
    }
}

export default moneyMixin;